/* ========================================================================
 *  Common Locations Module
 * ========================================================================
*/
FD.LOCATIONS = (function ($, me) {
    'use strict';

    var child = me.LOCATIONS || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_CONTACTMANAGER = '/ContactManager/ContactManager/';

    var PARENT_ELEM = '[data-parent="true"]';
    var MODAL_ELEM = '#LOCATION_MODULE_MODAL';
    var LOCATION_MODULE_PARENT_COMPANY_LIST = '#LOCATION_MODULE_PARENT_COMPANY_LIST';
    var LOCATION_MODULE_PARENT_COMPANY_SEARCH = '#LOCATION_MODULE_PARENT_COMPANY_SEARCH';
    var LOCATION_CONTACTS = '#LOCATION_CONTACTS';
    var MANUAL_LABOR_REMINDER = '#MANUAL_LABOR_REMINDER';
    var SUBSCRIBE_CONTACTS = '#SUBSCRIBE_CONTACTS';
    var ADD_LOC_SUPPLIER_NUMBER = '#ADD_LOC_SUPPLIER_NUMBER';
    var CODEQUALIFIER_DATA = '#CODEQUALIFIER_DATA';
    var LAST_MODIFIED_SPAN_LOCATION = "#LAST_MODIFIED_SPAN_LOCATION";
    var LOCATION_HEADER_NAME = "#LOCATION_HEADER_NAME";
    var IMPORTER_INFORMATION_TAB = "#IMPORTER_INFORMATION_TAB";
    var IMPORTER_INFORMATION = "#IMPORTER_INFORMATION";
    var SKID_INPUTS = ".SKID_INPUTS";
    var IPP_Tag_Input = ".ipp-tag-input";
    var SEND_DAILY_NOTIFICATION_INPUTS = ".SEND_DAILY_NOTIFICATION_INPUTS";

    var modal;
    var notify = new Notify();
    var label = {};
    var locationOptions = {};
    var defaults = {
        locationID: null,       // Only used for edit modal
        addCallback: null,      // Function called once a location is added (new or existing)
        hideCallback: null,     // Function called once a modal is hidden
        editCallback: null,     // Function called after a location is edited
        editAfterAdd: false,    // If true, the edit modal will automatically be opened after adding a new/existing location
        addMultiple: false,     // If true, the add modal will clear out and stay open after adding a new/existing location
        allowExisting: true     // If true, the modal will also give the user the option to select an existing location in addition to creating a new one
    };
    var isEdit;
    var codeQualifierList;
    var nameInput;


    var countryType = {
        OTHER: 0,
        UNITED_STATES: 1,
        MEXICO: 2,
        CHINA: 3,
        HUNGARY: 4
    };


    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {
        ADD_EXISTING_LOCATION: 10,
        ADD_NEW_LOCATION: 11,

        EDIT_Name_CONIRMATION: 20,
        CONFIRMED_EDIT_Name: 39,
        CANCEL_EDIT_Name: 40,
        EDIT_Name: 21,
        EDIT_Phone: 22,
        EDIT_Fax: 23,
        EDIT_Email: 24,
        EDIT_IsActive: 25,
        EDIT_IsManualLabor: 26,
        EDIT_ParentID: 28,
        EDIT_Address1: 29,
        EDIT_Address2: 30,
        EDIT_City: 31,
        EDIT_State: 32,
        EDIT_ZipCode: 33,
        EDIT_Country: 34,
        EDIT_Notes: 35,
        EDIT_URL: 36,
        EDIT_HasInnotecLogin: 38,
        EDIT_PaymentTerms: 46,
        EDIT_ShippingTerms: 47,
        EDIT_IsShipTo: 48,
        EDIT_IsBillTo: 49,
        EDIT_LOCATION_CONTACTTYPE: 54,
        EDIT_LOCATION_REQUIRERETURNABLETOTE: 55,
        EDIT_HasImporter: 27,
        EDIT_BatchingAndSequencing: 41,
        EDIT_DisplayIPPTag: 42,
        EDIT_TaxID: 37,

        EDIT_IsTrailerNumberRequired: 90,
        EDIT_IsTrackingNumberRequired: 91,
        EDIT_IsDockNumberRequired: 92,
        EDIT_IsPortRequired: 93,
        EDIT_IsClassRequired: 94,
        EDIT_IsCustomTransitDaysRequired: 95,
        EDIT_PackslipNote: 96,
        EDIT_DefaultPartLabelTemplateID: 83,
        EDIT_DefaultPartLabelPrinterID: 84,
        EDIT_ProhibitMixedShipments: 97,

        PARENT_COMPANY_POPOVER: 50,
        SELECT_PARENT_COMPANY: 51,
        ADD_PARENT_COMPANY: 52,
        SEACH_PARENT_COMPANY: 53,

        // Mexico Specific Fields
        EDIT_Street: 60,
        EDIT_ExteriorNumber: 61,
        EDIT_InteriorNumber: 62,
        EDIT_Colony: 63,
        EDIT_Municipality: 64,

        //Shipping Settings
        EDIT_WEIGHTTYPE: 65,
        EDIT_PLANTNUMBER: 66,
        EDIT_DefaultContainerLabelTemplateID: 69,
        EDIT_DefaultMasterLabelTemplateID: 70,
        EDIT_SupplierNumber: 71,
        EDIT_ShippingAccountID: 72,
        EDIT_ShippingAccountNumber: 73,

        EDIT_CodeQualifier: 74,
        CONTACT_RECEIVE_MPT_EMAIL: 75,
        EDIT_CodeQualifierAdd: 76,
        EDIT_CodeQualifierDelete: 77,
        EDIT_MAX_DAYS_FOR_DEMAND_CALCULATION: 78,
        EDIT_CONTACT_ACCOUNT_REPRESENTATIVE: 79,

        EDIT_DiscountPercentage: 106,
        EDIT_DiscountWeekStart: 107,
        EDIT_DiscountWeeks: 108,

        EDIT_DockNumber: 80,

        CONFIRMED_ISACTIVE: 81,
        CANCELMODAL: 82,

        EDIT_UseSkidLabel: 101,
        EDIT_DefaultSkidLabelSerialConstant: 102,
        EDIT_DefaultSkidLabelTemplateID: 103,
        EDIT_DefaultSkidLabelPrinterID: 104,
        EDIT_DefaultSkidLabelQuantity: 105,
        EDIT_DefaultSkidLabelMixedTemplateID: 113,

        EDIT_SendDailyShipmentNotice: 109,
        EDIT_LocationEmail: 110,
        EDIT_UserOwnerID: 111,
        EDIT_Incoterm: 112,

        //Importer
        EDIT_Importer_Name: 125,
        EDIT_Importer_Country: 126,
        EDIT_Importer_Address1: 127,
        EDIT_Importer_Address2: 128,
        EDIT_Importer_Street: 129,
        EDIT_Importer_ExteriorNumber: 130,
        EDIT_Importer_InteriorNumber: 131,
        EDIT_Importer_Colony: 132,
        EDIT_Importer_City: 133,
        EDIT_Importer_Municipality: 134,
        EDIT_Importer_State: 135,
        EDIT_Importer_ZipCode: 136,
        EDIT_Importer_TaxID: 137,
        EDIT_Importer_Notes: 138,
    };


    /*
     * ========================================================================
     *  Objects
     * ========================================================================
    */


    function setLocationItem() {
        return {
            ID: locationOptions.locationID,
            Name: null,
            Phone: null,
            Fax: null,
            Email: null,
            IsActive: null,
            IsManualLabor: null,
            ParentID: null,
            ParentName: null,
            Address1: null,
            Address2: null,
            Street: null,
            ExteriorNumber: null,
            InteriorNumber: null,
            Colony: null,
            City: null,
            Municipality: null,
            State: null,
            ZipCode: null,
            CountryType: null,
            Country: null,
            Notes: null,
            URL: null,
            HasInnotecLogin: null,
            PaymentTermID: null,
            ShippingTermID: null,
            ShippingAccountID: null,
            ShippingAccountNumber: null,
            DockNumber: null,
            LocationContactType: null,
            RequireReturnableToteSetter: null,
            IsTrailerNumberRequired: null,
            IsTrackingNumberRequired: null,
            IsDockNumberRequired: null,
            IsPortRequired: null,
            IsClassRequired: null,
            IsCustomTransitDaysRequired: null,
            PackslipNote: null,
            DefaultPartLabelTemplateID: null,
            DefaultPartLabelPrinterID: null,
            HasImporter: null,
            TaxID: null,
            SendDailyShipmentNotice: null,
            BatchingAndSequencing: null,
            DisplayIPPTag: null,
            ProhibitMixedShipments: null,
            UserOwnerID: null,
            Incoterm: null,
        };
    }

    /*
     * ========================================================================
     *  CRUD Functions
     * ========================================================================
    */


    function handleLocationFieldCRUD(updateItem, currentTag) {
        updateItem = $.extend({}, setLocationItem(), updateItem);

        var options = {
            params: {
                item: updateItem
            },
            url: URL_CONTACTMANAGER + "HandleLocationFieldCRUD",
            callback: afterData,
            isloader: true
        };
        var userItem = me.getUserProps();

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result) {
                if (locationOptions.editCallback) {
                    locationOptions.editCallback(locationOptions.locationID);
                }

                if (result && $(LAST_MODIFIED_SPAN_LOCATION).length > 0) {
                    var lastModifiedInfo = label.LastModifiedBy + ": "
                        + userItem.standardName + " - " + moment().format('L');
                    $(LAST_MODIFIED_SPAN_LOCATION).text(lastModifiedInfo);
                }

                if (currentTag === tag.EDIT_Name) {
                    $(LOCATION_HEADER_NAME).text(updateItem.Name);
                }
            }
        }
    }

    function handleImporterFieldCRUD(updateItem, currentTag) {
        updateItem = $.extend({}, setLocationItem(), updateItem);

        var options = {
            params: {
                item: updateItem
            },
            url: URL_CONTACTMANAGER + "HandleImporterFieldCRUD",
            callback: afterData,
            isloader: true
        };
        var userItem = me.getUserProps();

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result) {
                if (result && $(LAST_MODIFIED_SPAN_LOCATION).length > 0) {
                    var lastModifiedInfo = label.LastModifiedBy + ": "
                        + userItem.standardName + " - " + moment().format('L');
                    $(LAST_MODIFIED_SPAN_LOCATION).text(lastModifiedInfo);
                }
            }
        }
    }


    function handleContactReceiveDailyMPTReportCRUD(data) {
        var options = {
            params: {
                ID: data.parentid,
                ReceiveDailyMPTReport: data.value
            },
            url: URL_CONTACTMANAGER + "HandleContactFieldCRUD",
            isloader: true
        };

        me.AJAX.setAJAX(options);
    }


    function handleContactAccountRepCRUD(data) {
        $(".accountRepCheckbox").updateCheckbox({ value: false });
        data.e.updateCheckbox({ value: true });
        var options = {
            params: {
                id: data.parentid
            },
            url: URL_CONTACTMANAGER + "handleContactAccountRepCRUD",
            isloader: true
        };

        me.AJAX.setAJAX(options);
    }


    function handleLocationAddCRUD(data) {
        if (!me.CONTROL.Validate(MODAL_ELEM, false, false, true)) {
            return;
        }

        var parentID = +$(MODAL_ELEM).find('[data-tag="' + tag.PARENT_COMPANY_POPOVER + '"]').data('value');
        if (parentID <= 0) {
            notify.alert(me.getLabel()['YouMustAddressAllRequiredFields']);
            return;
        }

        var location = $.extend({}, setLocationItem(-1), me.getFormFields(MODAL_ELEM));
        location.ParentID = parentID;
        location.SupplierNumberList = [];
        $('[data-fd="text"]', ADD_LOC_SUPPLIER_NUMBER).each(function () {
            if ($(this).val()) {
                location.SupplierNumberList.push({ ShipFromID: Number($(this).closest('[data-parent]').data('parentid')), SupplierNumber: $(this).val() });
            }
        });
        location.CodeQualifierList = codeQualifierList;

        var options = {
            params: {
                newLocation: location
            },
            url: URL_CONTACTMANAGER + "HandleLocationAddCRUD",
            callback: afterData,
            isloader: true,
            loadingElements: data.e
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            resolveAddLocation(result.data, true);
        }
    }


    // When using an existing location, we just need to pass the ID back to the application
    function resolveAddLocation(newLocationID, isNew) {
        if (locationOptions.addCallback) {
            locationOptions.addCallback(newLocationID);
        }
        if (locationOptions.addMultiple) {
            clearAddLocationFields();
        } else {
            if (locationOptions.editAfterAdd) {
                locationOptions.locationID = newLocationID;
                $(MODAL_ELEM).on('hidden.bs.modal', function () {
                    getEditLocationModal();
                });
            }
            $(MODAL_ELEM).modal('hide');
        }
    }


    // Select this company as a parent company
    function selectParentCompany(data) {
        if (data.e.data('canlink') === false) {
            notify.alert(data.e.data('restrictedmessage'));
            return;
        }

        var parentCompanyNameElem = $(MODAL_ELEM).find('[data-tag="' + tag.PARENT_COMPANY_POPOVER + '"]').data('value', +data.parentid).find('span').text(data.e.text());
        WebuiPopovers.hideAll();
        data.e.webuiPopover("destroy");
        if (locationOptions.locationID) { // save data if we're editing
            handleLocationFieldCRUD({ ParentID: +data.parentid });
        }
    }


    function handleCompanyAddCRUD(data) {
        var options = {
            url: URL_CONTACTMANAGER + "HandleCompanyAddCRUD",
            params: {
                Name: data.e.data('companyname')
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data === -1) {
                notify.alert(label['CompanyAlreadyExistsWithThisName']);
            } else if (result.data > 0) {
                var parentCompanyButton = $(MODAL_ELEM).find('[data-tag="' + tag.PARENT_COMPANY_POPOVER + '"]');
                parentCompanyButton.data('value', result.data).find('span').text(data.e.data('companyname'));
                WebuiPopovers.hideAll();
                parentCompanyButton.webuiPopover("destroy");
                if (locationOptions.locationID) {
                    handleLocationFieldCRUD({ ParentID: result.data });
                }
            }
        }
    }

    function confirmIsActive(data) {
        if ($(data.e).data("ispreferredvendor") && data.value == false) {
            data.e.updateCheckbox({ value: true });
            returnPurchasedMaterialByVendorModal(data);
        } else if ($(data.e).data("isnotpreferredvendor") && data.value == false) {
            me.setConfirmDialogue(me.getLabel()['IsActiveConfirmationMessage'], tag.CONFIRMED_ISACTIVE, tag.CANCELMODAL, data.e.closest('[data-callbackprefix]').data('callbackprefix'));
        } else {
            handleLocationFieldCRUD({ IsActive: data.value });
        }
    }

    function returnPurchasedMaterialByVendorModal(data) {
        var options = {
            url: URL_CONTACTMANAGER + 'ReturnPurchasedMaterialByVendor',
            params: {
                vendorId: data.parentid,
                callbackPrefix: data.e.closest('[data-callbackprefix]').data('callbackprefix')
            },
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            var modal = $('<div id="CONFIRMATION_MODAL" class="modal fade"></div>');
            modal.html(result.data).off().on('hidden.bs.modal', function () {
                modal.remove();
            }).modal({
                backdrop: 'static',
                keyboard: false
            }).modal('show').enableControls();
        }
    }

    function handleSupplierNumberCRUD(data) {
        var options = {
            url: URL_CONTACTMANAGER + "HandleSupplierNumberCRUD",
            params: {
                ShipFromID: Number(data.parentid),
                ShipToID: locationOptions.locationID,
                SupplierNumber: data.value
            },
            isloader: true
        };

        me.AJAX.setAJAX(options);
    }


    function handleLocationCodeQualifierCRUD(data) {
        codeQualifierList = $("tr:not([data-noresults=true],[data-newrow=true],.footer)", CODEQUALIFIER_DATA).map(function () {
            return {
                ID: $(this).closest("[data-parent=true]").data("parentid"),
                IDCode: $("[name=IDCode]", this).val(),
                IDQualifier: $("[name=IDQualifier]", this).val()
            };
        }).filter(function () {
            return this.IDCode || this.IDQualifier;
        }).toArray();

        // Don't save on add modal.
        if (!locationOptions.locationID) {
            return;
        }

        var options = {
            url: URL_CONTACTMANAGER + "HandleLocationCodeQualifierCRUD",
            params: {
                locationID: locationOptions.locationID,
                codeQualifierList: codeQualifierList

            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            codeQualifierList = [];
            if (!result.data.result) {
                if (result.data.duplicate) {
                    notify.alert(me.getLabel()['DuplicateCodeQualifierError'] + ".<br> " + result.data.duplicate.IDCode + "|" + result.data.duplicate.IDQualifier + " in use on " + result.data.duplicate.LocationName);

                } else {
                    notify.alert(me.getLabel()['DuplicateCodeQualifierError']);
                }
            }
            returnCodeQualifierByLocation(!result.data);
        }
    }


    function handleLocationCodeQualifierAdd(data) {
        $("[data-newrow=true]", CODEQUALIFIER_DATA).before($("[data-newrow=true]", CODEQUALIFIER_DATA).clone().removeClass("hidden").attr("data-newrow", null));
        me.CONTROL.setText(true, CODEQUALIFIER_DATA);
        me.CONTROL.setButton(true, CODEQUALIFIER_DATA);
        $("[data-noresults=true]", CODEQUALIFIER_DATA).addClass("hidden");
    }


    function handleLocationCodeQualifierDeleteCRUD(data) {
        if (Number(data.parentid) == 0) {
            data.e.closest("tr").remove();
            if ($("tr:not([data-noresults=true],[data-newrow=true],.footer)", CODEQUALIFIER_DATA).length == 0) {
                $("[data-noresults=true]", CODEQUALIFIER_DATA).removeClass("hidden");
            }
            return;
        }
        // Don't save on add modal
        if (!locationOptions.locationID) {
            data.e.closest("tr").remove();
            return;
        }

        var options = {
            url: URL_CONTACTMANAGER + "HandleLocationCodeQualifierDeleteCRUD",
            params: {
                ID: Number(data.parentid)
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                if ($("tr:not([data-noresults=true],[data-newrow=true],.footer)", CODEQUALIFIER_DATA).length > 1) {
                    data.e.closest("tr").remove();
                } else {
                    returnCodeQualifierByLocation(true);
                }
            }
        }
    }

    /*
     * ========================================================================
     *  Views/Partial Views
     * ========================================================================
    */

    function returnCodeQualifierByLocation(reload) {
        var options = {
            params: {
                locationID: locationOptions.locationID
            },
            url: URL_CONTACTMANAGER + 'ReturnCodeQualifierByLocation',
            callback: afterData,
            isloader: true,
            cancelprevious: true,
            ishtml: true
        };
        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (reload) {
                $(CODEQUALIFIER_DATA).html(result.data);
            } else {
                var index = $(":focus", CODEQUALIFIER_DATA).closest("tr").index();
                var name = $(":focus", CODEQUALIFIER_DATA).attr("name");

                $(result.data).each(function () {
                    if ($(this).is("tr:not([data-noresults=true],[data-newrow=true],.footer)")) {

                        if ($('[data-parentid=' + $(this).data('parentid') + ']', CODEQUALIFIER_DATA).length > 0) {
                            $('[data-parentid=' + $(this).data('parentid') + ']', CODEQUALIFIER_DATA).replaceWith(this);
                        } else {
                            $("[data-newrow=true]", CODEQUALIFIER_DATA).before(this);
                        }
                    }
                });
                $("tr:not([data-noresults=true],[data-newrow=true],.footer)[data-parentid=0]").remove();
                $('[name=' + name + ']:eq(' + index + ')', CODEQUALIFIER_DATA).select();
            }

            me.CONTROL.setText(true, CODEQUALIFIER_DATA);
            me.CONTROL.setButton(true, CODEQUALIFIER_DATA);
        }
    }


    function getEditLocationModal() {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);
        var options = {
            params: {
                id: locationOptions.locationID
            },
            url: URL_CONTACTMANAGER + 'GetEditLocationModal',
            callback: afterData,
            isloader: true,
            cancelprevious: true
        };
        me.AJAX.setAJAX(options);

        function afterData(result) {
            $('body').append(result.data.HTML);
            label = JSON.parse(result.data.LabelList);
            var modal = $(MODAL_ELEM);
            modal.off().on('shown.bs.modal', function () {
                me.setToolTipDestroy();

                me.CONTROL.setValidateContainer(); // MUST BE FIRST
                me.CONTROL.setText(true, modal);
                me.CONTROL.setTextArea(true, modal);
                me.CONTROL.setButton(true, modal);
                me.CONTROL.setCheckBox(true, modal);
                me.CONTROL.setSelect(true, modal);
                me.CONTROL.setAutoComplete(modal);
                me.CONTROL.setNumber(true, modal);
                me.CONTROL.setScroll(modal);
                me.setToolTip();

                me.setModalLock(false);
                isEdit = true;
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                modal.remove();
                if (locationOptions.hideCallback) {
                    locationOptions.hideCallback();
                }
            }).modal('show');
        }
    }


    function getAddLocationModal() {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);
        var modal = $(MODAL_ELEM);

        var options = {
            params: {
                allowExisting: locationOptions.allowExisting,
                preSelectedCompanyID: locationOptions.selectedParentCompanyID
            },
            url: URL_CONTACTMANAGER + 'GetAddLocationModal',
            callback: afterData,
            isloader: true,
            cancelprevious: true
        };
        me.AJAX.setAJAX(options);

        function afterData(result) {
            $('body').append(result.data.HTML);
            label = JSON.parse(result.data.LabelList);
            var modal = $(MODAL_ELEM);
            modal.off().on('shown.bs.modal', function () {
                me.CONTROL.setValidateContainer(); // MUST BE FIRST
                me.CONTROL.setText(true, modal);
                me.CONTROL.setTextArea(true, modal);
                me.CONTROL.setButton(true, modal);
                me.CONTROL.setCheckBox(true, modal);
                me.CONTROL.setSelect(true, modal);
                me.CONTROL.setAutoComplete(modal);

                if (result.data.PreSelectedCompanyID > -1) {
                    modal.find('[data-tag="' + tag.PARENT_COMPANY_POPOVER + '"]')
                        .data('value', locationOptions.selectedParentCompanyID)
                        .find('span').text(locationOptions.selectedParentCompanyName);
                }

                me.setToolTipDestroy();
                me.setModalLock(false);
                isEdit = false;
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                modal.remove();
                if (locationOptions.hideCallback) {
                    locationOptions.hideCallback();
                }
            }).modal('show');
        }
    }


    function getParentCompanySearchPopover(data) {
        var options = {
            url: URL_CONTACTMANAGER + "GetParentCompanySearchPopover",
            params: {},
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                setCompanySearchPopover(data.e, result.data);
            }
        }
    }


    function setCompanySearchPopover(elem, html) {
        var options = {
            placement: 'right',
            multi: false,
            padding: false,
            cache: false,
            arrow: false,
            dismissible: true,
            content: function () {
                return html;
            },
            onHide: function (e) {
                $('body').removeClass('out');
            },
            width: '450',
            onShow: function () {
                me.CONTROL.setButton(true, null);
                me.CONTROL.setText(true, null);
                $(LOCATION_MODULE_PARENT_COMPANY_SEARCH).focus();
            },
            type: 'html'
        };

        WebuiPopovers.hideAll();
        elem.webuiPopover('destroy').webuiPopover(options).webuiPopover('show');
    }


    function getParentCompanyListBySearch(data) {
        var options = {
            url: URL_CONTACTMANAGER + "GetParentCompanyListBySearch",
            params: {
                searchTerm: data.value
            },
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(LOCATION_MODULE_PARENT_COMPANY_LIST).html(result.data);
                me.CONTROL.setButton(true, LOCATION_MODULE_PARENT_COMPANY_LIST);
            }
        }
    }


    function getLocationContactList() {
        var options = {
            url: URL_CONTACTMANAGER + "GetLocationContactList",
            params: {
                locationID: locationOptions.locationID
            },
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(LOCATION_CONTACTS).find('.list-group').html(result.data);
                me.CONTROL.setCheckBox(true, LOCATION_CONTACTS);
            }
        }
    }


    /*
    * ========================================================================
    * Helper Functions
    * ========================================================================
    */


    function clearAddLocationFields() {
        var modal = $(MODAL_ELEM);
        modal.find('input').val(null).data('value', null).data('initial', null);
        modal.find('textarea').val(null).data('value', null).data('initial', null);
        modal.find('[data-fd="checkbox"]').updateCheckbox({ value: false });
    }


    function handleCountryTypeChange(data) {
        if (data.value === 'Mexico') {
            $('.standard-address').addClass('hidden');
            $('.mexico-address').removeClass('hidden');
        } else {
            $('.standard-address').removeClass('hidden');
            $('.mexico-address').addClass('hidden');
        }

        if (isEdit) {
            handleLocationFieldCRUD({ Country: data.value });
        }
    }


    function hideShowMPTEmailReportCheckBoxes(data) {
        var locationContactsElem = $(LOCATION_CONTACTS);
        if (data.value) {
            locationContactsElem.find(MANUAL_LABOR_REMINDER).addClass('hidden');
            locationContactsElem.find(SUBSCRIBE_CONTACTS).removeClass('hidden');
            locationContactsElem.find('[data-tag="' + tag.CONTACT_RECEIVE_MPT_EMAIL + '"]').updateCheckbox({ enable: true });
        } else {
            locationContactsElem.find(MANUAL_LABOR_REMINDER).removeClass('hidden');
            locationContactsElem.find(SUBSCRIBE_CONTACTS).addClass('hidden');
            locationContactsElem.find('[data-tag="' + tag.CONTACT_RECEIVE_MPT_EMAIL + '"]').updateCheckbox({ enable: false });
        }
    }



    /* ========================================================================
     *  Page Init
     * ========================================================================
    */


    child.init = function () { };


    child.getAddModal = function (userOptions) {
        locationOptions = $.extend({}, defaults, userOptions);
        locationOptions.locationID = null;
        getAddLocationModal();
    }


    child.getEditModal = function (userOptions) {
        locationOptions = $.extend({}, defaults, userOptions);
        if (!locationOptions.locationID) {
            window.console && console.error("No location ID was provided");
            return;
        }
        getEditLocationModal();
    }


    //   after control event
    child.getAfterControlEvent = function (data) {
        var result = data;
        switch (result.tag) {
            // Add Location Functionality
            case tag.ADD_EXISTING_LOCATION:
                resolveAddLocation(+result.value);
                break;
            case tag.ADD_NEW_LOCATION:
                handleLocationAddCRUD(result);
                break;

            // Parent Company Functionality
            case tag.PARENT_COMPANY_POPOVER:
                getParentCompanySearchPopover(result);
                break;
            case tag.SELECT_PARENT_COMPANY:
                selectParentCompany(result);
                break;
            case tag.ADD_PARENT_COMPANY:
                handleCompanyAddCRUD(result);
                break;
            case tag.SEACH_PARENT_COMPANY:
                getParentCompanyListBySearch(result);
                break;

            // Field CRUD tags
            case tag.EDIT_Name_CONIRMATION:
                nameInput = data;
                me.setConfirmDialogue(me.getLabel()['ChangeContactNameWarning'], tag.CONFIRMED_EDIT_Name, tag.CANCEL_EDIT_Name, data.e.closest('[data-callbackprefix]').data('callbackprefix'));
                break;
            case tag.CONFIRMED_EDIT_Name:
                me.hideConfirmDialogue(child.handleSecondModalClose);
                handleLocationFieldCRUD({ Name: nameInput.value }, nameInput.tag);
                break;
            case tag.CANCEL_EDIT_Name:
                me.hideConfirmDialogue(child.handleSecondModalClose);
                nameInput.e.val(nameInput.initial);
                break;
            case tag.EDIT_Name:
                handleLocationFieldCRUD({ Name: data.value }, data.tag);
                break;
            case tag.EDIT_Phone:
                handleLocationFieldCRUD({ Phone: data.value });
                break;
            case tag.EDIT_Fax:
                handleLocationFieldCRUD({ Fax: data.value });
                break;
            case tag.EDIT_Email:
                handleLocationFieldCRUD({ Email: data.value });
                break;
            case tag.EDIT_IsActive:
                confirmIsActive(data);
                break;
            case tag.EDIT_IsManualLabor:
                handleLocationFieldCRUD({ IsManualLabor: data.value });
                hideShowMPTEmailReportCheckBoxes(data);
                break;
            case tag.EDIT_ParentID:
                handleLocationFieldCRUD({ ParentID: data.value });
                break;
            case tag.EDIT_LOCATION_CONTACTTYPE:
                handleLocationFieldCRUD({ LocationContactType: data.value });
                break;
            case tag.EDIT_LOCATION_REQUIRERETURNABLETOTE:
                handleLocationFieldCRUD({ RequireReturnableToteSetter: data.value });
                break;
            case tag.EDIT_Country:
                handleCountryTypeChange(data);
                break;
            case tag.EDIT_Address1:
                handleLocationFieldCRUD({ Address1: data.value });
                break;
            case tag.EDIT_Address2:
                handleLocationFieldCRUD({ Address2: data.value });
                break;
            case tag.EDIT_Street:
                handleLocationFieldCRUD({ Street: data.value });
                break;
            case tag.EDIT_ExteriorNumber:
                handleLocationFieldCRUD({ ExteriorNumber: data.value });
                break;
            case tag.EDIT_InteriorNumber:
                handleLocationFieldCRUD({ InteriorNumber: data.value });
                break;
            case tag.EDIT_Colony:
                handleLocationFieldCRUD({ Colony: data.value });
                break;
            case tag.EDIT_City:
                handleLocationFieldCRUD({ City: data.value });
                break;
            case tag.EDIT_Municipality:
                handleLocationFieldCRUD({ Municipality: data.value });
                break;
            case tag.EDIT_State:
                handleLocationFieldCRUD({ State: data.value });
                break;
            case tag.EDIT_ZipCode:
                handleLocationFieldCRUD({ ZipCode: data.value });
                break;
            case tag.EDIT_Notes:
                handleLocationFieldCRUD({ Notes: data.value });
                break;
            case tag.EDIT_URL:
                handleLocationFieldCRUD({ URL: data.value });
                break;
            case tag.EDIT_TaxID:
                handleLocationFieldCRUD({ TaxID: data.value });
                break;
            case tag.EDIT_HasImporter:
                $(IMPORTER_INFORMATION_TAB).toggleClass("hidden", !data.value);
                $(IMPORTER_INFORMATION).toggleClass("hidden", !data.value);
                handleLocationFieldCRUD({ HasImporter: data.value });
                break;
            case tag.EDIT_BatchingAndSequencing:
                handleLocationFieldCRUD({ BatchingAndSequencing: data.value });
                break;
            case tag.EDIT_DisplayIPPTag:
                handleLocationFieldCRUD({ DisplayIPPTag: data.value });
                break;
            case tag.EDIT_HasInnotecLogin:
                handleLocationFieldCRUD({ HasInnotecLogin: data.value });
                break;
            case tag.EDIT_PaymentTerms:
                handleLocationFieldCRUD({ PaymentTermID: data.value });
                break;
            case tag.EDIT_ShippingTerms:
                handleLocationFieldCRUD({ ShippingTermID: data.value });
                break;
            case tag.EDIT_WEIGHTTYPE:
                data.e.find('option[value="-1"]').remove();
                handleLocationFieldCRUD({ WeightType: data.value });
                break;
            case tag.EDIT_PLANTNUMBER:
                handleLocationFieldCRUD({ PlantNumber: data.value });
                break;
            case tag.EDIT_DefaultContainerLabelTemplateID:
                handleLocationFieldCRUD({ DefaultContainerLabelTemplateID: data.value });
                break;
            case tag.EDIT_DefaultMasterLabelTemplateID:
                handleLocationFieldCRUD({ DefaultMasterLabelTemplateID: data.value });
                break;
            case tag.EDIT_ShippingAccountID:
                handleLocationFieldCRUD({ ShippingAccountID: Number(data.value) });
                break;
            case tag.EDIT_ShippingAccountNumber:
                handleLocationFieldCRUD({ ShippingAccountNumber: data.value });
                break;
            case tag.CONTACT_RECEIVE_MPT_EMAIL:
                handleContactReceiveDailyMPTReportCRUD(data);
                break;
            case tag.EDIT_CONTACT_ACCOUNT_REPRESENTATIVE:
                handleContactAccountRepCRUD(data);
                break;
            case tag.EDIT_SupplierNumber:
                handleSupplierNumberCRUD(data);
                break;
            case tag.EDIT_CodeQualifier:
                handleLocationCodeQualifierCRUD(data);
                break;
            case tag.EDIT_CodeQualifierAdd:
                handleLocationCodeQualifierAdd(data);
                break;
            case tag.EDIT_CodeQualifierDelete:
                handleLocationCodeQualifierDeleteCRUD(data);
                break;
            case tag.EDIT_IsShipTo:
                $(IPP_Tag_Input).toggleClass("hidden", !data.value);
                handleLocationFieldCRUD({ IsShipTo: data.value });
                break;
            case tag.EDIT_IsBillTo:
                handleLocationFieldCRUD({ IsBillTo: data.value });
                break;
            case tag.EDIT_MAX_DAYS_FOR_DEMAND_CALCULATION:
                handleLocationFieldCRUD({ MaxDaysForDemandCalculation: data.value === null ? -1 : data.value });
                break;
            case tag.EDIT_DiscountPercentage:
                handleLocationFieldCRUD({ DiscountPercentage: data.value === null ? -1 : data.value });
                break;
            case tag.EDIT_DiscountWeekStart:
                handleLocationFieldCRUD({ DiscountWeekStart: data.value === null ? -1 : data.value });
                break;
            case tag.EDIT_DiscountWeeks:
                handleLocationFieldCRUD({ DiscountWeeks: data.value === null ? -1 : data.value });
                break;
            case tag.EDIT_DockNumber:
                handleLocationFieldCRUD({ DockNumber: data.value });
                break;
            case tag.CONFIRMED_ISACTIVE:
                handleLocationFieldCRUD({ IsActive: false });
                me.hideConfirmDialogue();
                break;
            case tag.CANCELMODAL:
                me.hideConfirmDialogue();
                $('[data-tag=' + tag.EDIT_IsActive + ']').updateCheckbox({ value: true });
                break;
            case tag.EDIT_IsTrailerNumberRequired:
                handleLocationFieldCRUD({ IsTrailerNumberRequired: data.value });
                break;
            case tag.EDIT_IsTrackingNumberRequired:
                handleLocationFieldCRUD({ IsTrackingNumberRequired: data.value });
                break;
            case tag.EDIT_IsDockNumberRequired:
                handleLocationFieldCRUD({ IsDockNumberRequired: data.value });
                break;
            case tag.EDIT_IsPortRequired:
                handleLocationFieldCRUD({ IsPortRequired: data.value });
                break;
            case tag.EDIT_IsClassRequired:
                handleLocationFieldCRUD({ IsClassRequired: data.value });
                break;
            case tag.EDIT_IsCustomTransitDaysRequired:
                handleLocationFieldCRUD({ IsCustomTransitDaysRequired: data.value });
                break;
            case tag.EDIT_PackslipNote:
                handleLocationFieldCRUD({ PackslipNote: data.value });
                break;
            case tag.EDIT_DefaultPartLabelTemplateID:
                handleLocationFieldCRUD({ DefaultPartLabelTemplateID: data.value });
                break;
            case tag.EDIT_DefaultPartLabelPrinterID:
                handleLocationFieldCRUD({ DefaultPartLabelPrinterID: data.value });
                break;
            case tag.EDIT_ProhibitMixedShipments:
                handleLocationFieldCRUD({ ProhibitMixedShipments: data.value });
                break;
            case tag.EDIT_Incoterm:
                handleLocationFieldCRUD({ Incoterm: data.value });
                break;

            case tag.EDIT_UseSkidLabel:
                handleLocationFieldCRUD({ ID: data.parentid, UseSkidLabel: data.value });
                $(SKID_INPUTS).toggleClass("hidden", !data.value);
                break;
            case tag.EDIT_DefaultSkidLabelSerialConstant:
                handleLocationFieldCRUD({ ID: data.parentid, DefaultSkidLabelSerialConstant: data.value });
                break;
            case tag.EDIT_DefaultSkidLabelTemplateID:
                handleLocationFieldCRUD({ ID: data.parentid, DefaultSkidLabelTemplateID: data.value });
                break;
            case tag.EDIT_DefaultSkidLabelMixedTemplateID:
                handleLocationFieldCRUD({ ID: data.parentid, DefaultSkidLabelMixedTemplateID: data.value });
                break;
            case tag.EDIT_DefaultSkidLabelPrinterID:
                handleLocationFieldCRUD({ ID: data.parentid, DefaultSkidLabelPrinterID: data.value });
                break;
            case tag.EDIT_DefaultSkidLabelQuantity:
                handleLocationFieldCRUD({ ID: data.parentid, DefaultSkidLabelQuantity: data.value });
                break;
            case tag.EDIT_SendDailyShipmentNotice:
                $(SEND_DAILY_NOTIFICATION_INPUTS).toggleClass("hidden", !data.value);
                handleLocationFieldCRUD({ ID: data.parentid, SendDailyShipmentNotice: data.value });
                break;
            case tag.EDIT_LocationEmail:
                handleLocationFieldCRUD({ ID: data.parentid, Email: data.value });
                break;
            case tag.EDIT_UserOwnerID:
                handleLocationFieldCRUD({ UserOwnerID: data.value });
                break;

            //importer fields
            case
                tag.EDIT_Importer_Name:
                handleImporterFieldCRUD({ Name: data.value });
                break;
            case tag.EDIT_Importer_Country:
                if (data.value === 'Mexico') {
                    $(IMPORTER_INFORMATION).find('.standard-address').addClass('hidden');
                    $(IMPORTER_INFORMATION).find('.mexico-address').removeClass('hidden');
                } else {
                    $(IMPORTER_INFORMATION).find('.standard-address').removeClass('hidden');
                    $(IMPORTER_INFORMATION).find('.mexico-address').addClass('hidden');
                }
                handleImporterFieldCRUD({ Country: data.value });
                break;
            case tag.EDIT_Importer_Address1:
                handleImporterFieldCRUD({ Address1: data.value });
                break;
            case tag.EDIT_Importer_Address2:
                handleImporterFieldCRUD({ Address2: data.value });
                break;
            case tag.EDIT_Importer_Street:
                handleImporterFieldCRUD({ Street: data.value });
                break;
            case tag.EDIT_Importer_ExteriorNumber:
                handleImporterFieldCRUD({ ExteriorNumber: data.value });
                break;
            case tag.EDIT_Importer_InteriorNumber:
                handleImporterFieldCRUD({ InteriorNumber: data.value });
                break;
            case tag.EDIT_Importer_Colony:
                handleImporterFieldCRUD({ Colony: data.value });
                break;
            case tag.EDIT_Importer_City:
                handleImporterFieldCRUD({ City: data.value });
                break;
            case tag.EDIT_Importer_Municipality:
                handleImporterFieldCRUD({ Municipality: data.value });
                break;
            case tag.EDIT_Importer_State:
                handleImporterFieldCRUD({ State: data.value });
                break;
            case tag.EDIT_Importer_ZipCode:
                handleImporterFieldCRUD({ ZipCode: data.value });
                break;
            case tag.EDIT_Importer_TaxID:
                handleImporterFieldCRUD({ TaxID: data.value });
                break;
            case tag.EDIT_Importer_Notes:
                handleImporterFieldCRUD({ Notes: data.value });
                break;
        }
    };

    child.handleSecondModalClose = function () {
        $('body').addClass("modal-open");
    }

    return child;
}(jQuery, FD));